import { jsPDF } from "jspdf";
import "./PdfJson.css";

const generateInvoicePdf = (invoice, formData) => {
  const calculateSummary = (shifts) => {
    const totalAmount = shifts.reduce((sum, shift) => sum + shift.amount, 0);
    const payableExpenses = shifts.reduce((sum, shift) => sum + shift.payableExpenses, 0);
    const totalPenalties = shifts.reduce((sum, shift) => sum + shift.penalty, 0);
    const grossAmount = totalAmount + payableExpenses - totalPenalties;

    return {
      totalAmount,
      payableExpenses,
      totalPenalties,
      grossAmount,
    };
  };

  const summary = calculateSummary(invoice);
  const invoiceData = {
    companyName: "KK SECURITY SERVICES LIMITED",
    companyAddress: "C E M E Innovation Centre, RM13 8EU",
    date: "19-01-2025",
    period: `${formData?.startDate || ""} - ${formData?.endDate || ""}`,
    subcontractor: {
      id: "7",
      name: formData?.subcontractor || "",
      address: formData?.subContractorAddress || "",
      contactNumber: formData?.subContractorContactNumber || "",
      email: formData?.subContractorEmail || "",
    },
    shifts: invoice,
    summary,
  };

  const doc = new jsPDF();

  // Set initial positions
  let yPos = 15;
  const margin = 10;
  const pageHeight = doc.internal.pageSize.height;

  // Add company header
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text(invoiceData.companyName, doc.internal.pageSize.width / 2, yPos, {
    align: "center",
  });

  yPos += 8;
  doc.setFontSize(10);
  doc.text(
    invoiceData.companyAddress,
    doc.internal.pageSize.width / 2,
    yPos,
    { align: "center" }
  );

  yPos += 8;
  doc.text("SUBCONTRACTOR INVOICE", doc.internal.pageSize.width / 2, yPos, {
    align: "center",
  });

  // Add invoice details
  yPos += 10;
  doc.setFont("helvetica", "normal");
  doc.text(`Date: ${invoiceData.date}`, margin, yPos);
  doc.text(
    `Period: ${`${formData?.startDate || ""} - ${formData?.endDate || ""}`}`,
    doc.internal.pageSize.width - margin,
    yPos,
    { align: "right" }
  );

  // Add subcontractor details
  yPos += 8;
  doc.text(`S. ID: ${invoiceData.subcontractor.id}`, margin, yPos);
  doc.text(
    `Subcontractor Name: ${invoiceData.subcontractor.name}`,
    margin + 40,
    yPos
  );
  doc.text(
    `Contact Number: ${invoiceData.subcontractor.contactNumber}`,
    doc.internal.pageSize.width - margin,
    yPos,
    { align: "right" }
  );

  yPos += 8;
  doc.text(
    `Subcontractor Address: ${invoiceData.subcontractor.address}`,
    margin,
    yPos
  );

  // Add table headers
  yPos += 10;
  const headers = ["Name", "Rate", "Amount"];
  const columnWidths = [50, 15, 15];

  // Draw header cells
  let xPos = margin;
  doc.setFontSize(8);
  doc.setFont("helvetica", "bold");
  headers.forEach((header, i) => {
    doc.text(header, xPos + 1, yPos);
    xPos += columnWidths[i];
  });

  // Add table data
  doc.setFont("helvetica", "normal");
  yPos += 5;
  invoiceData.shifts.forEach((shift) => {
    xPos = margin;

    // Check if we need to add a new page
    if (yPos > pageHeight - 20) {
      doc.addPage();
      yPos = 15;
    }

    doc.text(shift.employeeName || "KK Security", xPos + 1, yPos);
    xPos += columnWidths[0];

    doc.text(`£${shift.payableRate.toFixed(2)}`, xPos + 1, yPos);
    xPos += columnWidths[1];

    doc.text(`£${shift.amount.toFixed(2)}`, xPos + 1, yPos);
    xPos += columnWidths[2];

    yPos += 8;
  });

  // Add summary with right alignment
  yPos += 5;
  doc.setFontSize(9);
  const summaryX = doc.internal.pageSize.width - 60;

  doc.text(
    `Total Amount: £${invoiceData.summary.totalAmount}`,
    summaryX,
    yPos
  );
  yPos += 6;
  if (formData?.payableExpenses) {
    doc.text(
      `Payable Expenses: £${invoiceData.summary.payableExpenses}`,
      summaryX,
      yPos
    );
    yPos += 6;
  }
  doc.text(
    `Total Penalties: £${invoiceData.summary.totalPenalties}`,
    summaryX,
    yPos
  );
  yPos += 6;
  doc.text(
    `Gross Amount: £${invoiceData.summary.grossAmount}`,
    summaryX,
    yPos
  );

  doc.save("subcontractor-invoice.pdf");
};

export default generateInvoicePdf;
